export const isJest = () => process.env.NODE_ENV === 'test' && process.env.JEST_WORKER_ID;
